import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { libraryShape, promoShape } from '@bibliocommons/bc-prop-types';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import ModalActions from 'app/actions/ModalActions';
import cardShape from 'app/shapes/cardShape';
import { selectFeatureStatuses } from 'app/selectors/FeatureTogglzSelector';
import SearchAnalyticsContext from 'app/components/search/SearchAnalyticsContext';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectPromoEntities } from 'app/selectors/EntitiesSelector';
import { selectCardSearchParameters } from 'app/selectors/CardsSelector';
import { selectInterestedEvents } from 'app/selectors/events/EventsSearchSelector';
import PersonalizedPromotions from './PersonalizedPromotions';

export class PersonalizedPromotionsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleTitleClick(card) {
    const { position, promos, promoSearchRequestId } = this.props;

    const { trackCardTitleClick } = this.context;

    const promo = promos?.get(card?.get('id').toString());

    trackCardTitleClick({ card, position, promo, promoSearchRequestId });
  }

  handleImageClick(card) {
    const { position, promos, promoSearchRequestId } = this.props;

    const { trackCardImageClick } = this.context;

    const promo = promos?.get(card?.get('id').toString());

    trackCardImageClick({ card, position, promo, promoSearchRequestId });
  }

  handleContentImpression(card) {
    const { position, promos, promoSearchRequestId } = this.props;

    const { trackCardImpression } = this.context;

    const promo = promos?.get(card?.get('id').toString());

    trackCardImpression({ card, position, promo, promoSearchRequestId });
  }

  handleContentExplore(card, linkText) {
    const { position, promos, promoSearchRequestId } = this.props;

    const promo = promos?.get(card?.get('id').toString());

    const { trackCardExploreClick } = this.context;

    trackCardExploreClick({ card, linkText, position, promo, promoSearchRequestId });
  }

  handleCardEventInterestedClick(card) {
    const { position, promos, promoSearchRequestId } = this.props;

    const { trackCardEventInterestedClick } = this.context;

    const promo = promos?.get(card?.get('id').toString());

    trackCardEventInterestedClick({ card, position, promo, promoSearchRequestId });
  }

  render() {
    return (
      <PersonalizedPromotions
        {...this.props}
        handleImageClick={this.handleImageClick}
        handleTitleClick={this.handleTitleClick}
        handleContentImpression={this.handleContentImpression}
        handleContentExplore={this.handleContentExplore}
        handleCardEventInterestedClick={this.handleCardEventInterestedClick}
      />
    );
  }
}

PersonalizedPromotionsContainer.contextType = SearchAnalyticsContext;

PersonalizedPromotionsContainer.propTypes = {
  // ownProps
  position: PropTypes.number.isRequired,
  cards: ImmutablePropTypes.listOf(cardShape),
  debugEnabled: PropTypes.bool,

  // Redux props
  currentLibrary: libraryShape.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  promoSearchRequestId: PropTypes.string.isRequired,
  promos: ImmutablePropTypes.mapOf(promoShape).isRequired,
  features: ImmutablePropTypes.mapOf(PropTypes.bool, PropTypes.oneOf(Object.values(TOGGLZ_FEATURES))).isRequired,
  interestedEvents: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      registrationId: PropTypes.string.isRequired,
      eventIds: PropTypes.object.isRequired
    })
  ),
  trackContentExplore: PropTypes.func
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  promoSearchRequestId: selectCardSearchParameters(state).get('requestId'),
  promos: selectPromoEntities(state),
  features: selectFeatureStatuses(state),
  interestedEvents: selectInterestedEvents(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalizedPromotionsContainer);
